import * as React from "react";
import PrivateEntityIcon from "./PrivateProjectIcon";

const PrivateProjectLabel = () => <div
    className="private-entity-label">
    <PrivateEntityIcon solid />
    Private Project
</div>
export default PrivateProjectLabel;